var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgName = function SvgName(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "name-a",
    x1: "0%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00B1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "name-b",
    x1: "0%",
    x2: "101.131%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FB0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#name-a)",
    d: "M3 16v32h58V16H3zm-1-3h60a2 2 0 0 1 2 2v34a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V15a2 2 0 0 1 2-2zm53 1h3v36h-3V14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#name-b)",
    d: "M9 42V22H7.5a1.5 1.5 0 0 1 0-3h6a1.5 1.5 0 0 1 0 3H12v20h1.5a1.5 1.5 0 0 1 0 3h-6a1.5 1.5 0 0 1 0-3H9z"
  }))));
};
export default SvgName;